module.exports = __webpack_public_path__ + "static/media/time-17.04ef6981.svg";